var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    fill: "#ffffff",
    id: "like",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.934 15.304c.044-.096.066-.199.066-.304v-3c0-1.654-1.346-3-3-3h-6v-4.5c0-1.655-1.346-3-3-3h-2.25c-.414 0-.75.336-.75.75v3.55l-2.901 5.078c-.066.114-.099.241-.099.372v10.5c0 .414.336.75.75.75h12.038c1.185 0 2.262-.701 2.74-1.782zM.75 22.5h3.75v-12h-3.75c-.414 0-.75.336-.75.75v10.5c0 .414.336.75.75.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLike);
export default __webpack_public_path__ + "static/media/youtube-like.ae8df6d78c4dca4f4a193c41a273151e.svg";
export { ForwardRef as ReactComponent };